import axios from "axios";
import AxiosInstance from "./axios";
import interceptors from "./axios";
import { getFreeCardImageAsync } from "../utils/cardImageHelper";

export const getTokenizationKey = async (Company_Id) => {
  try {
    const response = await AxiosInstance.get(
      `v1/nmi/nmi_public_key/${Company_Id}`
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};
export const getTokenizationKeyCustomer = async (CustomerId) => {
  try {
    const response = await AxiosInstance.get(
      `v1/nmi/nmi_public_key_customer/${CustomerId}`
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};
export const addCardDetails = async (payload) => {
  try {
    // Dejavoo uses only getDejavooToken (dejavoo-tokenize-card) from AddCardDetailsForm
    const response = await AxiosInstance.post(`v1/nmi/add-customer-card`, payload);
    return response?.data;
  } catch (error) {
    throw error;
  }
};
export const getCustomerVaultId = async (CustomerId) => {
  try {
    const response = await AxiosInstance.get(
      `v1/nmi/getCreditCards/${CustomerId}`
    );

    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const getCardDetails = async (payload) => {
  try {
    const response = await AxiosInstance.post(
      `v1/nmi/get-billing-customer-vault`,
      payload
    );

    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const getRecurringCards = async (id) => {
  try {
    const response = await AxiosInstance.get(
      `/v1/recurring-payment/recurring-payments/${id}`
    );

    return response?.data;
  } catch (error) {
    if (typeof error === "string") throw error;
    else if (Object.keys(error).length) throw JSON.stringify(error);
    else throw "Network problem";
  }
};

export const addRecurringCards = async (data) => {
  try {
    const response = await AxiosInstance.post(
      `/v1/recurring-payment/add-cards`,
      data
    );
    return response?.data;
  } catch (error) {
    if (typeof error === "string") throw error;
    else if (Object.keys(error).length) throw JSON.stringify(error);
    else throw "Network problem";
  }
};

export const updateRecurringCard = async (recurringId, data) => {
  if (typeof recurringId !== "string" || !recurringId) {
    throw new Error("Invalid recurringId provided.");
  }
  if (typeof data !== "object" || data === null) {
    throw new Error("Invalid data provided.");
  }

  try {
    const response = await AxiosInstance.put(
      `/v1/recurring-payment/${recurringId}`,
      data
    );
    return response?.data;
  } catch (error) {
    if (error?.response) {
      console.error("Error Response:", error?.response?.data);
      throw new Error(
        `Error ${error?.response?.status}: ${
          error?.response?.data?.message || "An error occurred"
        }`
      );
    } else if (error?.request) {
      console.error("Error Request:", error?.request);
      throw new Error("No response received from the server.");
    } else {
      console.error("Error Message:", error?.message);
      throw new Error(`Error: ${error?.message}`);
    }
  }
};



export const getCardType = async (cc_bin, cc_type) => {
  const options = {
    method: "POST",
    url: `https://bin-ip-checker.p.rapidapi.com/?bin=${cc_bin}`,

    headers: {
      "content-type": "application/json",
      "X-RapidAPI-Key": "1bd772d3c3msh11c1022dee1c2aep1557bajsn0ac41ea04ef7",
      "X-RapidAPI-Host": "bin-ip-checker.p.rapidapi.com",
    },
  };

  try {
    const response = await axios.request(options);
    return response?.data?.BIN?.type || cc_type;
  } catch (error) {
    return cc_type;
  }
};

export const getRentalOwnerCardTypeSettings = async (CustomerId) => {
  try {
    const response = await interceptors.get(
      `customer/payment_settings/${CustomerId}`
    );

    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const getCardLogo = async (cc_type, cc_number = null) => {
  try {
    // Use free card image API - no rate limits, supports all card types worldwide
    // Try with both card type and card number for better detection
    let imageUrl = await getFreeCardImageAsync(cc_type, cc_number);
    
    // If no image from type, try to detect from card number if available
    if (!imageUrl && cc_number) {
      const { getCardImageFromNumber } = await import("../utils/cardImageHelper");
      imageUrl = await getCardImageFromNumber(cc_number);
    }
    
    return imageUrl || "";
  } catch (error) {
    return "";
  }
};
export const getDejavooKey = async (CompanyId) => {
  try {
    const response = await AxiosInstance.get(`v1/nmi/dejavoo_key/${CompanyId}`);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Save Dejavoo card: send token + displayCcNumber to backend.
 * Backend stores only token + last4 + displayCcNumber (masked). No cc number, cvv, or exp stored in DB.
 */
export const getDejavooToken = async (CompanyId, cardData) => {
  try {
    const response = await AxiosInstance.post(
      "v1/nmi/dejavoo-tokenize-card",
      { ...cardData, CompanyId }
    );
    const data = response?.data;
    return {
      paymentToken: data?.payment_token_id,
      hashccnumber: data?.ccNumber,
    };
  } catch (error) {
    throw error;
  }
};